import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { OrgIdContext } from '../../store/orgId_context';
import cultures from './cultures';
import { DDD } from '../../lib/ddd/ddd';

/* const cultures = {
    "id": 44888847,
    "result": [{
            "Alias": "eu",
            "Culture": "en-US",
            "EnglishTitle": "English (European)",
            "NativeTitle": "English (European)",
            "IsoRegionName2": "us",
            "IsoRegionName3": "eng",
            "IsoCurrencySymbol": "USD",
            "NativeCurrencySymbol": "$",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/eu.svg"
        }, {
            "Alias": "sl-SI",
            "Culture": "sl-SI",
            "EnglishTitle": "Slovenian (Slovenia)",
            "NativeTitle": "Slovenščina (Slovenija)",
            "IsoRegionName2": "si",
            "IsoRegionName3": "slv",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/si.svg"
        }, {
            "Alias": "sr-Latn-RS",
            "Culture": "sr-Latn-RS",
            "EnglishTitle": "Serbian (Latin, Serbia)",
            "NativeTitle": "Srpski (Srbija)",
            "IsoRegionName2": "rs",
            "IsoRegionName3": "srp",
            "IsoCurrencySymbol": "RSD",
            "NativeCurrencySymbol": "RSD",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/rs.svg"
        }, {
            "Alias": "sr-Latn-ME",
            "Culture": "sr-Latn-ME",
            "EnglishTitle": "Montenegrin (Montenegro)",
            "NativeTitle": "Crnogorski (Crna Gora)",
            "IsoRegionName2": "me",
            "IsoRegionName3": "srp",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/me.svg"
        }, {
            "Alias": "hr-HR",
            "Culture": "hr-HR",
            "EnglishTitle": "Croatian (Croatia)",
            "NativeTitle": "Hrvatski (Hrvatska)",
            "IsoRegionName2": "hr",
            "IsoRegionName3": "hrv",
            "IsoCurrencySymbol": "HRK",
            "NativeCurrencySymbol": "kn",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/hr.svg"
        }, {
            "Alias": "mk-MK",
            "Culture": "mk-MK",
            "EnglishTitle": "Macedonian (North Macedonia)",
            "NativeTitle": "Makedonski (Severna Makedonija)",
            "IsoRegionName2": "mk",
            "IsoRegionName3": "mkd",
            "IsoCurrencySymbol": "MKD",
            "NativeCurrencySymbol": "ден",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/mk.svg"
        }, {
            "Alias": "it-IT",
            "Culture": "it-IT",
            "EnglishTitle": "Italian (Italy)",
            "NativeTitle": "Italiano (Italia)",
            "IsoRegionName2": "it",
            "IsoRegionName3": "ita",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/it.svg"
        }, {
            "Alias": "pl-PL",
            "Culture": "pl-PL",
            "EnglishTitle": "Polish (Poland)",
            "NativeTitle": "Polski (Polska)",
            "IsoRegionName2": "pl",
            "IsoRegionName3": "pol",
            "IsoCurrencySymbol": "PLN",
            "NativeCurrencySymbol": "zł",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/pl.svg"
        }, {
            "Alias": "ro-RO",
            "Culture": "ro-RO",
            "EnglishTitle": "Romanian (Romania)",
            "NativeTitle": "Română (România)",
            "IsoRegionName2": "ro",
            "IsoRegionName3": "ron",
            "IsoCurrencySymbol": "RON",
            "NativeCurrencySymbol": "RON",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/ro.svg"
        }, {
            "Alias": "fr-FR",
            "Culture": "fr-FR",
            "EnglishTitle": "French (France)",
            "NativeTitle": "Français (France)",
            "IsoRegionName2": "fr",
            "IsoRegionName3": "fra",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/fr.svg"
        }, {
            "Alias": "de-DE",
            "Culture": "de-DE",
            "EnglishTitle": "German (Germany)",
            "NativeTitle": "Deutsch (Deutschland)",
            "IsoRegionName2": "de",
            "IsoRegionName3": "deu",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/de.svg"
        }, {
            "Alias": "nl-NL",
            "Culture": "nl-NL",
            "EnglishTitle": "Dutch (Netherlands)",
            "NativeTitle": "Nederlands (Nederland)",
            "IsoRegionName2": "nl",
            "IsoRegionName3": "nld",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/nl.svg"
        }, {
            "Alias": "es-ES",
            "Culture": "es-ES",
            "EnglishTitle": "Spanish (Spain)",
            "NativeTitle": "Español (España)",
            "IsoRegionName2": "es",
            "IsoRegionName3": "spa",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/es.svg"
        }, {
            "Alias": "et-EE",
            "Culture": "et-EE",
            "EnglishTitle": "Estonian (Estonia)",
            "NativeTitle": "Eesti (Eesti)",
            "IsoRegionName2": "ee",
            "IsoRegionName3": "est",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/ee.svg"
        }, {
            "Alias": "sk-SK",
            "Culture": "sk-SK",
            "EnglishTitle": "Slovak (Slovakia)",
            "NativeTitle": "Slovenčina (Slovensko)",
            "IsoRegionName2": "sk",
            "IsoRegionName3": "slk",
            "IsoCurrencySymbol": "EUR",
            "NativeCurrencySymbol": "€",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/sk.svg"
        }, {
            "Alias": "cs-CZ",
            "Culture": "cs-CZ",
            "EnglishTitle": "Czech (Czech Republic)",
            "NativeTitle": "Čeština (Česká republika)",
            "IsoRegionName2": "cz",
            "IsoRegionName3": "ces",
            "IsoCurrencySymbol": "CZK",
            "NativeCurrencySymbol": "Kč",
            "FlagIconUrl4x3": "/Content/images/flag-icons/flags/4x3/cz.svg"
        }
    ]
} */

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

// The shared cultures list (used elsewhere for org/invoice culture settings, not just
// language switching) codes the generic "English (European)" entry as IsoRegionName2
// "us" — but i18next's own configured resource keys use "en" (see src/index.js). Left
// unreconciled, that mismatch means i18n.language is never exactly equal to any
// culture's IsoRegionName2 for a plain English session, so the flag/dropdown silently
// fell back to its first-entry default while the separate "EN"/"US" text label printed
// i18n.language raw — producing a flag and text that visibly didn't match. Normalizing
// only within this component (not the shared cultures data) keeps other consumers of
// cultures.js untouched.
// cultures.js's "English (Canada)" entry is coded IsoRegionName2 "ca" — the same key
// this app's i18next config (and src/locales/ca/) uses for Catalan. Both "us" (English
// European) and "ca" (English Canada) are genuinely English and must resolve to this
// app's "en" resource bundle, not fall through to the unrelated Catalan bundle.
const toI18nLng = (isoRegionName2) => (isoRegionName2 === "us" || isoRegionName2 === "ca") ? "en" : isoRegionName2;

// Reversing toI18nLng is lossy: both "us" and "ca" collapse to i18n language "en", so
// i18n.language alone can't tell us which flag was actually selected. Used only as a
// fallback default (see selectedCode below) when there's no other signal — defaults to
// the generic "us" (English European) entry.
const toCultureCode = (lng) => lng === "en" ? "us" : lng;

const getCookie = (name) => {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
};

function LanguageSelector({imgWidth=25}) {
  const { i18n } = useTranslation();
  const {sessionInfo} = useContext(OrgIdContext);

  // Since "en" is ambiguous between the "us" and "ca" dropdown entries, track which one
  // was actually picked in local state instead of re-deriving it from i18n.language on
  // every render (that always guesses "us"). changeCultureServer already persists the
  // full culture (e.g. "en-CA") in a cookie on every selection, so on mount we can read
  // it back to restore the right flag across page loads/navigations between the
  // Login/SignUp/ResetPassword/ChangePassword pages.
  const [selectedCode, setSelectedCode] = useState(() => {
    const cookieCulture = getCookie('d3pro.preferred-culture');
    const cookieMatch = cookieCulture && cultures.result.find(c => c.Culture === cookieCulture);
    if (cookieMatch) return cookieMatch.IsoRegionName2;
    return toCultureCode((i18n.language || "en").split("-")[0]);
  });

  const changeLanguage = (event) => {
    const code = event.target.value;
    i18n.changeLanguage(toI18nLng(code));
    changeCultureServer(code);
    setSelectedCode(code);
  };

  const changeCultureServer = (culture) => {
    const cc = cultures.result.find(c => c.IsoRegionName2 === culture);
    i18n.__culture=  cc.Culture;
    //document.cookie = `d3pro.preferred-culture=${cc.Culture}; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=None; Secure`;
    //console.log(`d3pro.preferred-culture=${cc.Culture}; path=/; max-age=31536000`);
    document.cookie = `d3pro.preferred-culture=${cc.Culture}; path=/; max-age=31536000; SameSite=Lax; Secure`;
    /* ddd.Rpc_ExecuteMethod("Auth.ChangeCulture", { culture: cc.Culture, persist:true }).finally(() => {
      document.cookie = `d3pro.preferred-culture=${cc.Culture}; path=/; max-age=31536000`;
    }); */
  };

  // i18next-browser-languagedetector caches the resolved language in localStorage (and
  // its own cookie) and applies it on every future mount, before this component ever
  // runs. Selecting "English (Canada)" under the old (pre-fix) mapping called
  // i18n.changeLanguage("ca"), which got cached that way — so a browser that tried it
  // once keeps loading real Catalan on every visit afterwards, even though the flag
  // itself (driven by the separate d3pro.preferred-culture cookie) correctly shows
  // Canada. There is no dropdown entry that legitimately maps to "ca" anymore (see
  // toI18nLng above), so a persisted "ca" can only be this stale leftover — self-heal
  // it back to English, which also re-caches the corrected value.
  useEffect(() => {
    if ((i18n.language || '').split('-')[0] === 'ca') {
      i18n.changeLanguage('en');
    }
  }, []);

  useEffect(() => {
    if(!sessionInfo) return;
    const defaultCulture = cultures.result.find(culture => culture.Culture === sessionInfo.Culture);
    if(defaultCulture) {
      i18n.changeLanguage(toI18nLng(defaultCulture.IsoRegionName2));
      setSelectedCode(defaultCulture.IsoRegionName2);
    }
  }, [sessionInfo]);

  return (
    <Select
      value={selectedCode}
      onChange={changeLanguage}
      // outline:none only (border removed from here) — a border set inline would win
      // over anything in sx below via plain CSS specificity, so it's defined there
      // instead where it can share hover/focus states with the background.
      style={{ outline: 'none' }}
      // At rest this used to render as a bare flag+chevron with no boundary at all,
      // which reads as unfinished/accidental rather than an intentional control —
      // especially right beside the SignUp stepper tab, where it had nothing to visually
      // separate it. A permanent light border (matching .loginInput's own #E7E7E7/10px
      // language) gives it the same "this is a real form control" boundary as every
      // other input on the page, at every state, not just on hover/focus.
      // The base .MuiOutlinedInput-notchedOutline border is zeroed since MUI reapplies
      // its own thicker primary-color version via the higher-specificity .Mui-focused
      // variant of that selector — left alone, opening the dropdown snapped a hard blue
      // rectangle around the flag. Our own border (below) + a soft tinted background on
      // hover/focus replaces it with something calmer and consistent with the rest of
      // the form.
      sx={{
        boxShadow: 'none',
        border: '1px solid #E7E7E7',
        borderRadius: '10px',
        transition: 'background-color 0.15s ease, border-color 0.15s ease',
        '.MuiOutlinedInput-notchedOutline': { border: 0 },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 0 },
        '.MuiSelect-select': { paddingTop: '2px', paddingBottom: '2px', display: 'flex', alignItems: 'center' },
        '&:hover': { backgroundColor: 'rgba(0, 67, 109, 0.06)', borderColor: '#0088BF' },
        '&.Mui-focused': { backgroundColor: 'rgba(0, 67, 109, 0.08)', borderColor: '#0088BF' },
      }}
      // The open list was pure MUI default: Roboto at 16px with a plain grey block for
      // the current language, which reads heavier and less finished than the rest of
      // these screens (all Poppins). These values are the same ones the legacy
      // /web/myaccount picker uses, so the two dropdowns are visually identical: Poppins
      // 14px in #747474, and the active language marked in the brand blue rather than
      // grey — the highlight is the only thing telling you what's currently selected,
      // so it should be legible at a glance.
      MenuProps={{
        PaperProps: {
          sx: {
            marginTop: '6px',
            borderRadius: '8px',
            border: '1px solid #E7E7E7',
            boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
            maxHeight: '320px',
            '& .MuiList-root': { paddingTop: '6px', paddingBottom: '6px' },
            '& .MuiMenuItem-root': {
              fontFamily: "'Poppins', -apple-system, BlinkMacSystemFont, sans-serif",
              fontSize: '14px',
              lineHeight: 1.4,
              color: '#747474',
              gap: '8px',
              padding: '8px 14px',
              minHeight: 'auto',
              whiteSpace: 'nowrap',
              '&:hover': { backgroundColor: '#F5F8FA' },
              // MUI applies .Mui-selected on its own, and re-applies its default grey
              // again for the hover/focus-visible combinations — each needs pinning or
              // the blue flickers back to grey on pointer/keyboard focus.
              '&.Mui-selected': {
                backgroundColor: '#F5F8FA',
                color: '#0088BF',
                fontWeight: 600,
              },
              '&.Mui-selected:hover': { backgroundColor: '#F5F8FA', color: '#0088BF' },
              '&.Mui-selected.Mui-focusVisible': { backgroundColor: '#F5F8FA', color: '#0088BF' },
            },
          },
        },
      }}
      renderValue={(value) => {
        let selectedCulture = cultures.result.find(culture => culture.IsoRegionName2 === value);
        if(!selectedCulture) selectedCulture = cultures.result[0];
        return (<img width={imgWidth} style={{margin:"3px", display:"block"}} src={(process.env.REACT_APP_ORIGIN || window.location.origin)+"/"+selectedCulture["FlagIconUrl4x3"]} alt="English (European)" />);
      }}
    >
      {cultures.result.map((culture) => {if(!culture) return;
        // 25px was oversized against the 14px text set above; 20px matches the flag-to-
        // text ratio of the legacy picker. Spacing comes from the row's `gap` now, so the
        // old per-image margin would double it up.
        return (<MenuItem key={culture.Alias} value={culture.IsoRegionName2}>
          <img width="20" style={{display:"block", flexShrink:0}} src={(process.env.REACT_APP_ORIGIN || window.location.origin)+"/"+culture["FlagIconUrl4x3"]} alt={culture.NativeTitle} />
          {culture.NativeTitle}
        </MenuItem>)
      })}
    </Select>
  );
}

export default LanguageSelector;